import React, { TableHTMLAttributes } from "react";
import cn from "classnames";

export type TableProps = TableHTMLAttributes<HTMLTableElement> & {
  card?: boolean;
  noWrap?: boolean;
  striped?: boolean;
  vcenter?: boolean;
};

export const Table = (props: TableProps) => {
  const { card, className, children, noWrap, striped, vcenter, ...rest } =
    props;
  return (
    <table
      className={cn(
        "table",
        {
          "table-vcenter": vcenter,
          "card-table": card,
          "table-striped": striped,
          "text-nowrap": noWrap,
        },
        className
      )}
      // {...rest}
    >
      {children}
    </table>
  );
};

export default Table;
